import React, { useEffect, useState } from 'react';
import { X, ChevronDown } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  links: Array<{
    name: string;
    path: string;
    submenu?: Array<{
      name: string;
      path: string;
    }>;
  }>;
}
export function MobileNav({
  isOpen,
  onClose,
  links
}: MobileNavProps) {
  const location = useLocation();
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);
  // Close nav when route changes
  useEffect(() => {
    onClose();
  }, [location.pathname, onClose]);
  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <>
      {/* Backdrop */}
      <div className={`fixed inset-0 bg-charcoal-900/20 backdrop-blur-sm z-40 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={onClose} data-id="element-125" />

      {/* Drawer */}
      <div className={`fixed top-0 right-0 h-full w-[300px] bg-cream-100 shadow-2xl z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-126">
        <div className="p-6 flex justify-end" data-id="element-127">
          <button onClick={onClose} className="p-2 text-charcoal-900 hover:text-sage-500 transition-colors" aria-label="Close menu" data-id="element-128">
            <X size={24} data-id="element-129" />
          </button>
        </div>

        <nav className="px-8 py-4" data-id="element-130">
          <ul className="space-y-6" data-id="element-131">
            {links.map(link => <li key={link.path} data-id="element-132">
                {link.submenu ? <div data-id="element-133">
                    <button onClick={() => setOpenSubmenu(openSubmenu === link.name ? null : link.name)} className={`flex items-center justify-between w-full text-2xl font-serif ${location.pathname === link.path || link.submenu.some(sub => sub.path === location.pathname) ? 'text-sage-500 italic' : 'text-charcoal-900 hover:text-sage-500'} transition-colors`} data-id="element-134">
                      {link.name}
                      <ChevronDown size={20} className={`transform transition-transform ${openSubmenu === link.name ? 'rotate-180' : ''}`} data-id="element-135" />
                    </button>
                    {openSubmenu === link.name && <ul className="mt-3 ml-4 space-y-3" data-id="element-136">
                        {link.submenu.map(sublink => <li key={sublink.path} data-id="element-137">
                            <Link to={sublink.path} className={`block text-lg ${location.pathname === sublink.path ? 'text-sage-500 italic' : 'text-charcoal-900/70 hover:text-sage-500'} transition-colors`} data-id="element-138">
                              {sublink.name}
                            </Link>
                          </li>)}
                      </ul>}
                  </div> : <Link to={link.path} className={`block text-2xl font-serif ${location.pathname === link.path ? 'text-sage-500 italic' : 'text-charcoal-900 hover:text-sage-500'} transition-colors`} data-id="element-139">
                    {link.name}
                  </Link>}
              </li>)}
          </ul>
        </nav>

        <div className="absolute bottom-8 left-0 w-full px-8 text-center" data-id="element-140">
          <p className="text-sm text-charcoal-900/60 font-sans" data-id="element-141">
            Down Home Interiors
            <br data-id="element-142" />
            Howell, MI
          </p>
        </div>
      </div>
    </>;
}